import { useTranslations } from 'next-intl';
import { useContext } from 'react';

import { MaterialDesignIcon } from '@hrworks/sui-core/MaterialDesignIcon';
import { CarouselContext } from '@hrworks/sui-extension/Carousel';

import { S } from './NavigationButton.styles';
import type { NavigationButtonProps } from './NavigationButton.types';

export const NavigationButton = ({ direction, ...otherProps }: NavigationButtonProps) => {
  const { prevDisabled, nextDisabled, scrollPrev, scrollNext } = useContext(CarouselContext);
  const t = useTranslations('CompanyMedia');

  const isDisabled = direction === 'prev' ? prevDisabled : nextDisabled;

  if (isDisabled) {
    return null;
  }

  const onClick = direction === 'prev' ? scrollPrev : scrollNext;

  return (
    <S.Wrapper direction={direction} {...otherProps}>
      <S.IconButton
        onClick={onClick}
        variant="unstyled"
        $direction={direction}
        aria-label={direction === 'prev' ? t('previousImage') : t('nextImage')}
      >
        <MaterialDesignIcon name="arrow_downward" />
      </S.IconButton>
    </S.Wrapper>
  );
};
